import classes from './LoginPage.module.css';

/**
 * Tessellated 8-polygon keyvisual ported from vdz-online.de.
 * Geometry and per-polygon entrance offsets verbatim from VDZ's <defs>.
 * Colors retoned to the local vdzGray palette.
 */
export function LoginBackground() {
  return (
    <svg
      viewBox="0 0 1360 944"
      preserveAspectRatio="xMinYMax slice"
      aria-hidden="true"
      style={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
      }}
    >
      <defs>
        <path
          id="el-1"
          d="M624.54,0 L624.80,568.40 L0,207.78 L0,0 L624.54,0 Z"
        />
        <path
          id="el-2"
          d="M624.60,0 L1360,0 L1360,464.02 L1123.20,600.45 L846,440.40 L624.80,568.38 L624.60,0 Z"
        />
        <path
          id="el-3"
          d="M1012.29,944 L514.09,944 L514.12,760.20 L403.30,696.26 L624.80,568.40 L1012.27,791.93 L1012.29,944 Z"
        />
        <path
          id="el-4"
          d="M1360,865.09 L1360,944 L1012.28,944 L1012.30,664.5 L1360,865.09 Z"
        />
        <path
          id="el-5"
          d="M1360,463.71 L1360,864.99 L1012.30,664.5 L1360,463.71 Z"
        />
        <path
          id="el-6"
          d="M624.80,568.40 L846,440.40 L1123.20,600.45 L1012.27,664.5 L1012.27,791.93 L624.80,568.40 Z"
        />
        <path
          id="el-7"
          d="M0,718.68 L0,481.42 L237.11,344.50 L624.80,568.40 L181.94,824.02 L0,718.68 Z"
        />
        <path
          id="el-8"
          d="M0,929.32 L403.30,696.26 L514.12,760.20 L514.12,944 L0,944 L0,929.32 Z"
        />

        <linearGradient id="fg-dark-horizontal-1" x1="100%" y1="0%" x2="0%" y2="0%" gradientTransform="rotate(10)">
          <stop offset="30%" stopColor="#b9b6b0" stopOpacity="0" />
          <stop offset="100%" stopColor="#b9b6b0" stopOpacity="1" />
        </linearGradient>

        <linearGradient id="fg-dark-dia" x1="0" y1="100%" x2="0%" y2="0%" gradientTransform="rotate(-20)">
          <stop offset="30%" stopColor="#b9b6b0" stopOpacity="0" />
          <stop offset="100%" stopColor="#b9b6b0" stopOpacity="0.4" />
        </linearGradient>

        <linearGradient id="to-right-mid-horizontal-1" x1="100%" y1="0%" x2="0%" y2="0%">
          <stop offset="40%" stopColor="#b9b6b0" stopOpacity="0" />
          <stop offset="100%" stopColor="#b9b6b0" stopOpacity="0.5" />
        </linearGradient>

        <linearGradient id="fg-dark-hz" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="10%" stopColor="#8f8b89" stopOpacity="0" />
          <stop offset="100%" stopColor="#8f8b89" stopOpacity="0.8" />
        </linearGradient>

        <linearGradient id="fg-light-vert" x1="0%" y1="0%" x2="0%" y2="100%" gradientTransform="rotate(30)">
          <stop offset="10%" stopColor="#b9b6b0" stopOpacity="0.1" />
          <stop offset="100%" stopColor="#b9b6b0" stopOpacity="0.8" />
        </linearGradient>

        <linearGradient id="bg-darkdeg-1" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(30)">
          <stop offset="40%" stopColor="#b9b6b0" stopOpacity="0" />
          <stop offset="100%" stopColor="#b9b6b0" stopOpacity="0.6" />
        </linearGradient>

        <linearGradient id="fg-dark-vert" x1="0%" y1="0%" x2="0%" y2="100%" gradientTransform="rotate(30)">
          <stop offset="10%" stopColor="#8f8b89" stopOpacity="0.1" />
          <stop offset="100%" stopColor="#8f8b89" stopOpacity="0.8" />
        </linearGradient>
      </defs>

      <g
        className={`${classes.polygon} ${classes.polygonWave4}`}
        style={{ '--dx': '-77px', '--dy': '-45px' } as React.CSSProperties}
      >
        <use href="#el-1" fill="url(#fg-dark-horizontal-1)" />
      </g>
      <g
        className={`${classes.polygon} ${classes.polygonWave4}`}
        style={{ '--dx': '0px', '--dy': '-75px' } as React.CSSProperties}
      >
        <use href="#el-2" fill="url(#fg-dark-dia)" />
      </g>
      <g
        className={`${classes.polygon} ${classes.polygonWave1}`}
        style={{ '--dx': '0px', '--dy': '75px' } as React.CSSProperties}
      >
        <use href="#el-3" fill="url(#to-right-mid-horizontal-1)" />
      </g>
      <g
        className={`${classes.polygon} ${classes.polygonWave3}`}
        style={{ '--dx': '78px', '--dy': '45px' } as React.CSSProperties}
      >
        <use href="#el-4" fill="url(#fg-dark-hz)" />
      </g>
      <g
        className={`${classes.polygon} ${classes.polygonWave4}`}
        style={{ '--dx': '75px', '--dy': '0px' } as React.CSSProperties}
      >
        <use href="#el-5" fill="url(#fg-light-vert)" />
      </g>
      <g
        className={`${classes.polygon} ${classes.polygonWave2}`}
        style={{ '--dx': '75px', '--dy': '-45px' } as React.CSSProperties}
      >
        <use href="#el-6" fill="url(#bg-darkdeg-1)" />
      </g>
      <g
        className={`${classes.polygon} ${classes.polygonWave3}`}
        style={{ '--dx': '-75px', '--dy': '0px' } as React.CSSProperties}
      >
        <use href="#el-7" fill="url(#fg-light-vert)" />
      </g>
      <g
        className={`${classes.polygon} ${classes.polygonWave2}`}
        style={{ '--dx': '-78px', '--dy': '45px' } as React.CSSProperties}
      >
        <use href="#el-8" fill="url(#fg-dark-vert)" />
      </g>
    </svg>
  );
}
